import { GridRowSelectionModel } from '@mui/x-data-grid';
import { createContext, useContext } from 'react';

import { Contract } from '../validationSchemas/ContractSchema';

export type ContractManagerContextType = {
  contract: Contract;
  selectedLineItems: any[];
  selectedLineItemIds: GridRowSelectionModel;
  setSelectedLineItemIds: (ids: GridRowSelectionModel) => void;
  setSelectedLineItems: (items: any[]) => void;
  selectedAdGroupIds: GridRowSelectionModel;
  selectedAdGroups: any[];
  setSelectedAdGroupIds: (ids: GridRowSelectionModel) => void;
  setSelectedAdGroups: (items: any[]) => void;
  isLoading: boolean;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  tabIcons: { [tab: string]: any };
  setTabIcons: React.Dispatch<React.SetStateAction<{ [tab: string]: any }>>;
};

export const ContractManagerContext = createContext<ContractManagerContextType | undefined>(undefined);

export const useContractManagerContext = (): ContractManagerContextType => useContext(ContractManagerContext);
